export default {"src":"/_next/static/media/ic_right_arrow.939a615a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};